import React from 'react';
 import classes from './Projects.module.css';
import Navbar from '../../components/Navbar/Navbar';
import { Col, Container,Row } from 'react-bootstrap';
import pic1 from '../../Images/codeera.png';
import pic2 from '../../Images/hdfc.png';
import pic3 from '../../Images/chess.png';
import pic4 from '../../Images/instagram.png'

const projects=()=>{
    return (
        <div>
            <Navbar />
            <div className={classes.Projects}>
            <div className={classes.content}>Projects List</div>
            <Container>
                <Row className={classes.row}>
                    <Col>
                        <a href="https://github.com/Nikhil14311?tab=repositories" 
                        alt="Projects" target="_blank"
                        rel="noreferrer">
                            <img src={pic1} alt="Burger Project" />
                            <p>Code Era</p>
                        </a>
                        
                    </Col>
                    <Col>
                        <a href="https://github.com/Nikhil14311?tab=repositories" 
                        alt="Projects" target="_blank"
                        rel="noreferrer">
                            <img src={pic2} alt="Loan Application Project" />
                            <p>HDFC Bank Application</p>
                        </a>
                        
                    </Col>
                </Row>
                <Row className={classes.row}>
                    <Col>
                        <a href="https://github.com/Nikhil14311?tab=repositories" 
                        alt="Projects" target="_blank"
                        rel="noreferrer">
                            <img src={pic3} alt="Cricket Team" />
                            <p>Chess Game</p>
                        </a>
                        
                    </Col>
                    <Col>
                        <a href="https://github.com/Nikhil14311?tab=repositories" 
                        alt="Projects" target="_blank"
                        rel="noreferrer">
                            <img src={pic4} alt="Instagram" />
                            <p>Instagram</p>
                        </a>

                    </Col>
                </Row>
            </Container>
            </div>
            
        </div>
    )
}

export default projects;